export interface APIError {
  statusCode?: number
  message: string
  data?: string
  errors?: any[]
  raw?: Error
}

export class CustomError extends Error {
  statusCode?: number
  message: string
  data?: string
  errors?: any[]
  raw?: Error
  constructor(error: APIError) {
    super(error.message)
    this.statusCode = error.statusCode
    this.message = error.message
    this.data = error.data
    this.errors = error.errors
    this.raw = error.raw
  }
}
